// extracted by mini-css-extract-plugin
export default {"track":"switch_track__qjkQI","isDisabled":"switch_isDisabled__vEV4O","isReadOnly":"switch_isReadOnly__+QqQe","thumb":"switch_thumb__TBSA6","input":"switch_input__kJaYU"};